import { accessTypeEnum } from './../../lib/enum';

const addAccessRight = [
  accessTypeEnum.admin,
  accessTypeEnum.editingFuelPrice
];

export default addAccessRight;
